import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceAddResourceGroupNotificationState = createStateReducer(
  initialState,
  {
    [events.addResourceGroupSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "addResourceGroup",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.addResourceGroupFailed]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "addResourceGroup",
          flags: ["failure"],
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceAddResourceGroupNotificationState };
